import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { App } from './App';
import './index.css';

const domain = import.meta.env.VITE_AUTH0_DOMAIN || 'auth.weiai.ai';
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID || 'yvfeEK61tGGpqd8Ca5hsCkDaTwo8Iqxh';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
